<template>
  <v-app>
    <v-toolbar color="cyan" dark>
      <v-spacer />
      <v-toolbar-title>Make your Setlist!</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <setlist/>
  </v-app>
</template>

<script>
import Setlist from './components/Setlist'

export default {
  name: 'App',
  components: {
    Setlist
  },
  data () {
    return {
      //
    }
  }
}
</script>